import React from 'react';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import withPendingArrangments from 'decorators/withPendingArrangments';
import Pagination from 'components/Pagination/Pagination';
import PendingArrangementList from 'components/PendingArrangement/PendingArrangementList';
import { purchaseMassAction } from 'actions/purchases';
import { getIncludedInGroups } from 'reducers';
import PendingArrangementActionBar from '../../components/PendingArrangement/PendingArrangementActionBar';
import ConfirmModal from '../../components/ConfirmModal/ConfirmModal';
import FormError from '../../components/FormError';
import Spinner from '../../components/Spinner';

class PendingArrangements extends React.Component {
  state = {
    selected: [],
    allCheckbox: false,
    loading: false,
    isOpenModal: false,
    modalText: '',
    error: '',
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.page !== this.props.page ||
      prevProps.type !== this.props.type
    ) {
      this.setState({
        selected: [],
        allCheckbox: false,
      });
    }
  }

  closeModal = () => this.setState({ isOpenModal: false });

  handleCheckboxClick = (id) => {
    const { selected } = this.state;

    if (selected.includes(id)) {
      this.setState({
        selected: selected.filter((selectedId) => selectedId !== id),
      });
    } else {
      this.setState({
        selected: [...selected, id],
      });
    }
  };

  handleChangeType = (type = 'all') => {
    this.props.history.push({ search: `?type=${type}` });
  };

  handleMassAction = (type) => {
    const { purchaseMassAction, pendingArrangements } = this.props;
    const { selected } = this.state;

    if (type === 'denied_arrangement' || type === 'arranged') {
      for (let purchaseId of selected) {
        const purchase = pendingArrangements.find(
          (purchase) => purchase.id === purchaseId,
        );

        if (purchase.status !== 'pending_arrangement') {
          const modalText = `You can't ${type === 'arranged' ? 'approve' : 'deny'} arrangements which are not Pending.`;
          this.setState({
            isOpenModal: true,
            modalText,
          });
          return;
        }
      }
    }

    this.setState({ loading: true, error: '' });
    purchaseMassAction(selected, type, pendingArrangements)
      .then(() => {
        this.setState({ loading: false });
      })
      .catch((e) => {
        this.setState({ loading: false, error: e.errors ? e.errors : e });
      });
  };

  selectAll = (e) => {
    const { pendingArrangements } = this.props;
    const checked = e.target.checked;

    if (checked) {
      this.setState({
        selected: pendingArrangements.map((purchase) => purchase.id),
        allCheckbox: true,
      });
    } else {
      this.setState({ selected: [], allCheckbox: false });
    }
  };

  paginationFunc = (pageNum) =>
    `/purchases/payment-arrangement?page=${pageNum}&type=${this.props.type}`;

  render() {
    const { selected, allCheckbox, error, isOpenModal, modalText, loading } =
      this.state;
    const {
      pendingArrangements,
      isAdminOrManagerOrBillingOrAgent,
      isReadOnlyAdmin,
      pageCount,
      page,
    } = this.props;

    if (!isAdminOrManagerOrBillingOrAgent && !isReadOnlyAdmin) {
      return <Redirect to={'/'} />;
    }

    return (
      <div>
        <h1>Payment Arrangements</h1>
        <Spinner showLoader={loading} />
        <PendingArrangementActionBar
          handleChangeType={this.handleChangeType}
          handleMassAction={this.handleMassAction}
          selectAll={this.selectAll}
          allCheckbox={allCheckbox}
        />
        {error && <FormError error={error} />}
        <PendingArrangementList
          purchases={pendingArrangements}
          handleCheckboxClick={this.handleCheckboxClick}
          selected={selected}
        />
        <ConfirmModal
          isOpen={isOpenModal}
          title="You can't do this action"
          description={modalText}
          onConfirm={this.closeModal}
          onClose={this.closeModal}
          confirmBtnText="Ok"
        />
        <Pagination
          count={pageCount}
          current={page}
          url={this.paginationFunc}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAdminOrManagerOrBillingOrAgent: getIncludedInGroups(state, [
    'ADMIN',
    'MANAGER',
    'BILLING',
    'AGENT',
  ]),
  isReadOnlyAdmin: getIncludedInGroups(state, ['READ_ONLY_ADMIN']),
});

const mapDispatchToProps = {
  purchaseMassAction,
};

export default compose(
  withPendingArrangments,
  connect(mapStateToProps, mapDispatchToProps),
)(PendingArrangements);
